export default [
  {
    name: "活动信息",
    propertyList: [
      {
        label: "店铺名称",
        prop: "venderName",
        checked: true,
        sortable: false,
        width: 120,
      },
      {
        label: "活动名称",
        prop: "activityName",
        checked: true,
        disabled: true,
        sortable: false,
        width: 120,
      },
      {
        label: "活动类型",
        prop: "activityType",
        slot: "activityType",
        width: 120,
        checked: true,
        sortable: false,
      },
      {
        label: "活动时间",
        prop: "activityTime",
        slot: "activityTime",
        width: 180,
        checked: true,
        sortable: false,
      },
    ],
  },
  {
    name: "互动数据",
    propertyList: [
      {
        label: "活动PV",
        prop: "activityPv",
        width: 120,
        checked: true,
        lineIndex: 1,
        tips: "活动页面累计访问次数",
        textAlign: "right",
      },
      {
        label: "活动UV",
        prop: "activityUv",
        width: 120,
        checked: true,
        lineIndex: 1,
        tips: "活动页面累计访问人数，同一用户多次访问只被计算一次",
        textAlign: "right",
      },
      {
        label: "参与次数",
        prop: "participateCount",
        width: 120,
        checked: true,
        lineIndex: 1,
        tips: "参与活动的次数，同个用户参与多次则计算多次",
        textAlign: "right",
      },
      {
        label: "参与人数",
        prop: "participateUserCount",
        width: 120,
        checked: true,
        lineIndex: 1,
        tips: "参与活动的人数，同一用户多次参与只被计算一次",
        textAlign: "right",
      },

      {
        label: "活动参与率",
        prop: "activityParticipateRate",
        width: 120,
        checked: true,
        lineIndex: 1,
        tips: "参与人数/活动UV",
        textAlign: "right",
      },
      {
        label: "新会员参与次数",
        prop: "newMemberParticipateCount",
        width: 150,
        checked: true,
        lineIndex: 2,
        tips: "统计时间段范围内，新会员参与次数，同个用户参与多次则计算多次",
        textAlign: "right",
      },
      {
        label: "新会员参与人数",
        prop: "newMemberParticipateUserCount",
        width: 150,
        checked: true,
        lineIndex: 2,
        tips: "统计时间段范围内，新会员参与人数，同一用户多次参与只被计算一次",
        textAlign: "right",
      },
      {
        label: "新会员参与率",
        prop: "newMemberParticipateRate",
        width: 150,
        checked: true,
        lineIndex: 2,
        tips: "新会员参与人数/活动访问UV",
        textAlign: "right",
      },
      {
        label: "老会员参与次数",
        prop: "oldMemberParticipateCount",
        width: 150,
        checked: true,
        lineIndex: 2,
        tips: "老会员定义：会员入会时间早于（不等于）活动开始时间老会员参与活动的次数，同个用户参与多次则计算多次",
        textAlign: "right",
      },
      {
        label: "老会员参与人数",
        prop: "oldMemberParticipateUserCount",
        width: 150,
        checked: true,
        lineIndex: 2,
        tips: "老会员：会员入会时间早于（不等于）活动开始时间老会员参与人数=老会员∩参与人数，同一用户多次参与只被计算一次（即用户pin维度去重）",
        textAlign: "right",
      },
      {
        label: "老会员参与率",
        prop: "oldMemberParticipateRate",
        width: 150,
        checked: true,
        lineIndex: 2,
        tips: "老会员参与人数/活动访问UV",
        textAlign: "right",
      },
      {
        label: "参与未中奖",
        name: "参与人数(未中奖)",
        prop: "participateNotWinCount",
        width: 120,
        checked: true,
        lineIndex: 3,
        tips: "参与活动但是未获得奖品的用户数",
        textAlign: "right",
      },
      {
        label: "参与已中奖",
        name: "参与人数(已中奖)",
        prop: "participateWinCount",
        width: 120,
        checked: true,
        lineIndex: 3,
        tips: "已中奖的用户数",
        textAlign: "right",
      },
    ],
  },
  {
    name: "中奖数据",
    propertyList: [
      {
        label: "中奖次数",
        prop: "winCount",
        checked: true,
        width: 120,
        tips: "中奖/领奖次数，个别活动一个用户可多次获得奖品",
        textAlign: "right",
      },
      {
        label: "中奖人数/领奖人数",
        name: "中奖人数",
        prop: "winUserCount",
        width: 180,
        checked: true,
        tips: "已中奖的用户数",
        textAlign: "right",
      },
      {
        label: "已填写地址人数",
        prop: "addressFilledUserCount",
        width: 150,
        checked: true,
        tips: "已中奖已填写地址",
        textAlign: "right",
      },
      {
        label: "未填写地址人数",
        prop: "addressNotFilledUserCount",
        width: 150,
        checked: true,
        tips: "已中奖未填写地址",
        textAlign: "right",
      },
    ],
  },
  {
    name: "交易数据",
    propertyList: [
      {
        label: "下单人数",
        prop: "orderUserCount",
        checked: true,
        width: 120,
        lineIndex: 1,
        tips: "在指定下单时间段内有提交订单的用户，同一用户多个订单只被计算一次（不排除取消）",
        textAlign: "right",
      },
      {
        label: "下单订单数",
        prop: "orderCount",
        width: 120,
        checked: true,
        lineIndex: 1,
        tips: "在指定下单时间段内提交订单的笔数（不排除取消）",
        textAlign: "right",
      },
      {
        label: "下单金额",
        prop: "orderAmount",
        width: 120,
        checked: true,
        lineIndex: 1,
        tips: "在指定下单时间段内提交订单的金额（不排除取消，pop为实付金额，自营为订单金额）",
        textAlign: "right",
      },
      {
        label: "下单件数",
        prop: "orderProductCount",
        width: 120,
        checked: true,
        lineIndex: 1,
        tips: "在指定下单时间段内提交的订单对应的商品件数（不排除取消订单）",
        textAlign: "right",
      },
      {
        label: "客单价（下单）",
        name: "客单价",
        prop: "orderCustomerPrice",
        width: 150,
        checked: true,
        lineIndex: 1,
        tips: "下单金额/下单人数",
        textAlign: "right",
      },
      {
        label: "件单价（下单）",
        name: "件单价",
        prop: "orderProductPrice",
        width: 150,
        checked: true,
        lineIndex: 1,
        tips: "下单金额/下单件数",
        textAlign: "right",
      },
      {
        label: "下单转化率",
        prop: "orderConversionRate",
        width: 120,
        checked: true,
        lineIndex: 1,
        tips: "下单人数/(活动UV)",
        textAlign: "right",
      },
      {
        label: "付款人数",
        prop: "payUserCount",
        width: 120,
        checked: true,
        lineIndex: 2,
        tips: "在指定下单时间段内有下单且至少有一笔已付款订单的用户数（不排除退款）",
        textAlign: "right",
      },
      {
        label: "付款订单数",
        prop: "payOrderCount",
        width: 120,
        checked: true,
        lineIndex: 2,
        tips: "在指定下单时间段有下单且已付款的订单笔数（不排除退款）",
        textAlign: "right",
      },
      {
        label: "付款金额",
        prop: "payAmount",
        width: 120,
        checked: true,
        lineIndex: 2,
        tips: "在指定下单时间段内有下单且已付款的订单金额（不排除退款，pop为实付金额，自营为订单金额）",
        textAlign: "right",
      },
      {
        label: "付款件数",
        prop: "payProductCount",
        width: 120,
        checked: true,
        lineIndex: 2,
        tips: "在指定下单时间段有下单且已付款订单对应的商品件数",
        textAlign: "right",
      },
      {
        label: "客单价（付款）",
        name: "客单价",
        prop: "payCustomerPrice",
        width: 150,
        checked: true,
        lineIndex: 2,
        tips: "付款金额/付款人数",
        textAlign: "right",
      },
      {
        label: "件单价（付款）",
        name: "件单价",
        prop: "payProductPrice",
        width: 150,
        checked: true,
        lineIndex: 2,
        tips: "付款金额/付款件数",
        textAlign: "right",
      },
      {
        label: "下单-付款转化率",
        prop: "orderPayConversionRate",
        width: 150,
        checked: true,
        lineIndex: 2,
        tips: "付款人数/下单人数*100%",
        textAlign: "right",
      },
      {
        label: "付款转化率",
        prop: "payConversionRate",
        width: 120,
        checked: true,
        lineIndex: 2,
        tips: "付款人数/活动UV",
        textAlign: "right",
      },
      {
        label: "完成人数",
        name: "成交人数",
        prop: "completeUserCount",
        width: 120,
        checked: true,
        lineIndex: 3,
        tips: "在指定下单时间段内有下单且至少有一笔已完成订单的用户数（不排除退款）",
        textAlign: "right",
      },
      {
        label: "完成订单数",
        name: "成交订单数",
        prop: "completeOrderCount",
        width: 120,
        checked: true,
        lineIndex: 3,
        tips: "在指定下单时间段有下单且已完成的订单笔数（不排除退款）",
        textAlign: "right",
      },
      {
        label: "完成金额",
        name: "成交金额",
        prop: "completeAmount",
        width: 120,
        checked: true,
        lineIndex: 3,
        tips: "在指定下单时间段内有下单且已完成的订单金额（不排除退款，pop为实付金额，自营为订单金额）",
        textAlign: "right",
      },
      {
        label: "完成件数",
        name: "成交件数",
        prop: "completeProductCount",
        width: 120,
        checked: true,
        lineIndex: 3,
        tips: "在指定下单时间段有下单且已完成订单对应的商品件数",
        textAlign: "right",
      },
      {
        label: "客单价（完成）",
        name: "客单价",
        prop: "completeCustomerPrice",
        width: 150,
        checked: true,
        lineIndex: 3,
        tips: "完成金额/完成人数",
        textAlign: "right",
      },
      {
        label: "件单价（完成）",
        name: "件单价",
        prop: "completeProductPrice",
        width: 150,
        checked: true,
        lineIndex: 3,
        tips: "完成金额/完成件数",
        textAlign: "right",
      },
      {
        label: "下单-完成转化率",
        prop: "orderCompleteConversionRate",
        width: 150,
        checked: true,
        lineIndex: 3,
        tips: "完成人数/下单人数",
        textAlign: "right",
      },
      {
        label: "完成转化率",
        prop: "completeConversionRate",
        width: 120,
        checked: true,
        lineIndex: 3,
        tips: "完成人数/活动UV",
        textAlign: "right",
      },
      {
        label: "下单未付款人数",
        prop: "orderNotPayUserCount",
        width: 150,
        checked: true,
        lineIndex: 4,
        tips: "下单未付款的用户数",
        textAlign: "right",
      },
      {
        label: "未付款订单数",
        name: "下单未付款订单数",
        prop: "notPayOrderCount",
        width: 150,
        checked: true,
        lineIndex: 4,
        tips: "下单未付款的订单数",
        textAlign: "right",
      },
      {
        label: "未付款金额",
        name: "下单未付款金额",
        prop: "notPayAmount",
        width: 120,
        checked: true,
        lineIndex: 4,
        tips: "下单未付款的订单金额（pop为实付金额，自营为订单金额）",
        textAlign: "right",
      },
      {
        label: "未付款件数",
        name: "下单未付款件数",
        prop: "notPayProductCount",
        width: 120,
        checked: true,
        lineIndex: 4,
        tips: "下单未付款订单的商品件数",
        textAlign: "right",
      },
      {
        label: "退款人数",
        prop: "refundUserCount",
        width: 120,
        checked: true,
        lineIndex: 5,
        tips: "付款订单存在退款订单的用户数（不包含订单完成后退款）",
        textAlign: "right",
      },
      {
        label: "退款订单数",
        prop: "refundOrderCount",
        width: 120,
        checked: true,
        lineIndex: 5,
        tips: "付款订单存在退款均会被统计（不包含订单完成后退款）",
        textAlign: "right",
      },
      {
        label: "订单取消率",
        name: "意向响应率",
        prop: "orderCancelRate",
        width: 120,
        checked: true,
        lineIndex: 5,
        tips: "未付款订单数/下单订单数",
        textAlign: "right",
      },
      {
        label: "退款金额",
        prop: "refundAmount",
        width: 120,
        checked: true,
        lineIndex: 5,
        tips: "付款订单中退款的订单金额，仅统计实际退款部分（不包含订单完成后退款）",
        textAlign: "right",
      },
      {
        label: "退款件数",
        prop: "refundProductCount",
        width: 120,
        checked: true,
        lineIndex: 5,
        tips: "付款订单存在付款的商品件数不包含订单完成后退款）",
        textAlign: "right",
      },
      {
        label: "退款率",
        prop: "refundRate",
        width: 120,
        checked: true,
        lineIndex: 5,
        tips: "退款订单数/付款订单数",
        textAlign: "right",
      },
    ],
  },
  {
    name: "店铺数据",
    propertyList: [
      {
        label: "店铺PV",
        name: "进店PV",
        prop: "shopPv",
        checked: true,
        width: 120,
        tips: "从活动进入店铺各页面的次数",
        textAlign: "right",
      },
      {
        label: "店铺UV",
        name: "进店UV",
        prop: "shopUv",
        width: 120,
        checked: true,
        tips: "从活动进入店铺各页面的人数，同一用户多次访问只被计算一次",
        textAlign: "right",
      },
      {
        label: "店铺浏览率",
        prop: "shopViewRate",
        width: 120,
        checked: true,
        tips: "店铺UV/活动UV",
        textAlign: "right",
      },
      {
        label: "关注店铺次数",
        prop: "followShopCount",
        width: 150,
        checked: true,
        tips: "通过活动关注了店铺的次数",
        textAlign: "right",
      },
      {
        label: "关注店铺人数",
        prop: "followShopUserCount",
        width: 150,
        checked: true,
        tips: "通过活动关注了店铺的人数，同一用户多次关注只被计算一次",
        textAlign: "right",
      },
      {
        label: "店铺关注率",
        prop: "shopFollowRate",
        width: 150,
        checked: true,
        tips: "关注店铺人数/活动UV",
        textAlign: "right",
      },
    ],
  },
  {
    name: "商品数据",
    propertyList: [
      {
        label: "商品PV",
        prop: "productPv",
        width: 120,
        checked: true,
        tips: "通过活动访问了商品详情页的次数",
        textAlign: "right",
      },
      {
        label: "商品UV",
        prop: "productUv",
        width: 120,
        checked: true,
        tips: "通过活动访问了商品详情页的次数，同一用户多次访问只被计算一次",
        textAlign: "right",
      },
      {
        label: "商品浏览率",
        prop: "productViewRate",
        width: 120,
        checked: true,
        tips: "商品UV/活动UV",
        textAlign: "right",
      },
    ],
  },
  {
    name: "裂变数据",
    propertyList: [
      {
        label: "分享活动次数",
        name: "分享次数",
        prop: "shareActivityCount",
        width: 150,
        checked: true,
        tips: "用户主动分享活动次数",
        textAlign: "right",
      },
      {
        label: "分享活动人数",
        name: "分享人数",
        prop: "shareActivityUserCount",
        width: 150,
        checked: true,
        tips: "主动分享了活动的用户数",
        textAlign: "right",
      },
      {
        label: "活动分享率",
        prop: "activityShareRate",
        width: 120,
        checked: true,
        tips: "分享活动人数/活动UV",
        textAlign: "right",
      },
    ],
  },
];
